import { useCallback } from 'react';

import { toast } from 'react-toastify';

import { FormattedMessage } from 'localization';

import { Error } from '../atoms';

const useShowError = () => {
  const onShowError = useCallback((message: any) => {
    toast.error(
      <Error message={message} title={<FormattedMessage id="general.action-failed" />} />,
    );
  }, []);

  return { onShowError };
};

export { useShowError };
